import Button from '@/components/Button/newButtons';

interface Props {
	isRetrying: boolean;
	handleRetry: () => void;
	onSkip?: () => void; // Optional skip handler
}

export default function OnboardingFailureModal({
	isRetrying,
	handleRetry,
	onSkip = () => {}
}: Props) {
	return (
		<div className="flex h-full w-full justify-center border-l border-dm-gray px-4 py-6 pb-20 text-white sm:py-20">
			<div className="flex w-full max-w-[43.75rem] flex-col justify-between gap-8 rounded-2xl border border-dm-orange bg-dm-black3/50 px-6 pb-10 pt-8 sm:h-[392px] sm:gap-6 sm:px-[52px] sm:pb-14 sm:pt-8">
				<div className="flex flex-col gap-6 font-barlow text-[1.25rem] font-semibold leading-[24px]">
					<p className="text-2xl font-semibold leading-10 text-dm-orange sm:text-2xl">
						Something went wrong while setting up your campaign
					</p>
					<div className="flex flex-col gap-3 text-xl leading-6 text-white">
						<p>
							No worries — sometimes things don&apos;t go as
							planned.
						</p>
						<p>
							You can try again to generate your list and
							sequence, or skip this setup and explore Resquared
							freely.
						</p>
					</div>
				</div>
				<div className="flex flex-col gap-4 sm:flex-row sm:justify-center sm:gap-40">
					<Button
						type="button"
						variant="secondary"
						className="h-8 w-full sm:w-[12.5rem]"
						onClick={onSkip}
					>
						Skip
					</Button>
					<Button
						type="button"
						variant="primary"
						className="h-8 w-full sm:w-[12.5rem]"
						onClick={handleRetry}
						disabled={isRetrying}
					>
						{isRetrying ? 'Re-trying...' : 'Re-try'}
					</Button>
				</div>
			</div>
		</div>
	);
}
